import React, { Component } from 'react';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxNombrePiece extends Component {

    static defaultProps = {
        label: "Pièces",
        placeholder: "Pièces",
    };


    render = () => {

        const fetchMethod = () => new Promise((resolve, reject) => {
            const nbPieces = [1, 2, 3, 4, 5, 6];
            resolve({ codeRetour: 0, reponseAPIobjet: nbPieces });
        });

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item}
            itemText={item => item}
        />;

    };

};